import React from 'react';

const NotFound = () => {
  return <div>Página não encontrada</div>;
};

export default NotFound;
